var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVimDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#242938",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#019833",
    d: "M135.498 39.4619C128.076 32.03 116.032 32.03 108.61 39.462L33.4081 114.765C26.0001 122.183 26.0001 134.199 33.4081 141.617L108.186 216.495C115.608 223.927 127.652 223.927 135.074 216.495L210.276 141.191C217.684 133.773 217.684 121.757 210.276 114.339L135.498 39.4619Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M161.769 40.7104L159.083 43.3988V53.2693L161.435 55.6235H173.86V65.1606L91.672 148.576V55.7425H105.331L108.133 52.9365V42.9482L105.546 40.9465H33.6672L31.3158 43.3007V53.5048L33.7069 55.8988H46.2085V216.316C46.2085 222.361 50.6553 227.485 56.6396 228.335V228.335C60.4891 228.883 64.3678 227.553 67.0718 224.759L235 51.2474V43.4001L232.315 40.7117L161.769 40.7104Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimDark);
export default __webpack_public_path__ + "static/media/VIM-Dark.0a6f8f77d2ca29dc2c1ccdcefcd3f331.svg";
export { ForwardRef as ReactComponent };